import { render, staticRenderFns } from "./HandlerPhonePopup.vue?vue&type=template&id=5ea0b01e&"
import script from "./HandlerPhonePopup.vue?vue&type=script&lang=js&"
export * from "./HandlerPhonePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports